module.exports = __webpack_public_path__ + "img/TALHADEIRA RETA PONTA CUNHA    - DESK.aa31956a.png";